import React from "react";
var defaultContext = {
  addToast: function addToast() {},
  removeToast: function removeToast() {}
};
export default /*#__PURE__*/React.createContext(defaultContext);